import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagDangerRounded = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--danger-rounded', className].filter(Boolean).join(' ')} />
);
